import React, { Component } from 'react';
import './App.css';
import { Patients, AddPatient, NoMatch, Auth } from './pages';
import { Router, Route, IndexRedirect, hashHistory } from 'react-router';
import store from './store';
import { connect } from 'react-redux';
import { app as actions } from './actions';

@connect(() => ({
}))
class App extends Component {

  constructor(props) {
    super(props);
    props.dispatch(actions.start());
  }
  
  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/">
          <IndexRedirect to="/patients" />
        </Route>
        <Route path="/login" component={Auth} />
        <Route path="/signup" component={Auth} />
        <Route path="/patients" component={Patients} onEnter={authenticate} />
        <Route path="/patients/new" component={AddPatient} onEnter={authenticate} />
        <Route path="/patients/:id" component={Patients} onEnter={authenticate} />
        <Route path="*" component={NoMatch}/>
      </Router>
    );
  }
}

function authenticate(nextState, replace) {
  const token = store.getState().session.get('sessionToken');
  if ( !token ) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname }
    });
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js